import { gql } from "~/__generated__"

gql(/* GraphQL */ `
  fragment EditorialSource on SourceItem {
    id
    title
    url
    summary
    publishedAt
    suggestion {
      id
      score
      rationale
      profileSection
      profileQuote
      sourceQuote
      reactionPrompt
      breakingCandidate
      current
      profileVersion
      createdAt
    }
    decision {
      status
      reason
    }
    feedSource {
      id
      name
    }
  }
`)

gql(/* GraphQL */ `
  fragment EditorialPost on ContentPost {
    id
    title
    body
    status
    lockVersion
    authorName
    editable
    approvedAt
    updatedAt
    sourceItem {
      ...EditorialSource
    }
    revisions {
      id
      title
      body
      number
      createdAt
    }
  }
`)

export const WORKSPACE = gql(/* GraphQL */ `
  query EditorialWorkspace {
    editorialWorkspace {
      hasExperienceProfile
      suggestionRun {
        id
        status
        error
        createdAt
      }
      sources {
        ...EditorialSource
      }
      posts {
        ...EditorialPost
      }
      feeds {
        id
        name
        lastSuccessAt
        lastAttemptAt
        lastError
      }
      reapConfigured
      pangramConfigured
    }
  }
`)

export const SAVE = gql(/* GraphQL */ `
  mutation SaveEditorialPost($input: ContentPostSaveInput!) {
    contentPostSave(input: $input) {
      post {
        ...EditorialPost
      }
    }
  }
`)
export const APPROVE = gql(/* GraphQL */ `
  mutation ApproveEditorialPost($input: ContentPostApproveInput!) {
    contentPostApprove(input: $input) {
      post {
        ...EditorialPost
      }
    }
  }
`)
export const REFRESH = gql(/* GraphQL */ `
  mutation RefreshEditorialSources {
    refreshEditorialSources(input: {}) {
      success
    }
  }
`)

gql(/* GraphQL */ `
  fragment RecordingSection on RecordingSection {
    included
    id
    position
    status
    transcript
    transcriptVersion
    transcriptRevisions {
      id
      number
      text
      createdAt
    }
    originalSegments {
      start
      end
      text
    }
    error
    videoUrl
  }
`)
gql(/* GraphQL */ `
  fragment ReactionPost on ContentPost {
    ...EditorialPost
    recordingSections {
      ...RecordingSection
    }
    approvalNote
    latestCheck {
      id
      body
      status
      score
      message
    }
    generations {
      id
      body
      status
      feedback
      profileVersion
      claimEvidence
      writingWarnings
      profileCurrent
      evidence
      createdAt
      pangramScore
      pangramMessage
    }
    latestGeneration {
      id
      status
      body
      error
      transcriptCurrent
      profileCurrent
      profileVersion
      claimEvidence
      writingWarnings
      pangramStatus
      pangramScore
      pangramMessage
    }
  }
`)
export const UPLOAD_RECORDING = gql(/* GraphQL */ `
  mutation UploadRecording($input: RecordingUploadInput!) {
    recordingUpload(input: $input) {
      section {
        ...RecordingSection
      }
      uploadUrl
      uploadHeaders
    }
  }
`)
export const TRANSCRIBE_RECORDING = gql(/* GraphQL */ `
  mutation TranscribeRecording($input: RecordingTranscribeInput!) {
    recordingTranscribe(input: $input) {
      section {
        ...RecordingSection
      }
    }
  }
`)
export const GENERATE_POST = gql(/* GraphQL */ `
  mutation GeneratePost($input: PostGenerateInput!) {
    postGenerate(input: $input) {
      generation {
        id
        status
        body
        error
        transcriptCurrent
        pangramStatus
        pangramScore
        pangramMessage
      }
    }
  }
`)
